import React, { createContext, useContext, useMemo, useState } from "react";
import AuthService from "Api/Auth";
import TextLimit from "Api/TextLimit";
import { rolesList } from "Components/Router/Permission";
import { useAbsenceCodes, useGroups, useOrganizations, useOrganizationUsers, useSchools } from "Api/Melder/Indinen/WizardContext";


const WizardContext = createContext();

export const WizardContextProvider = ({ children }) => {
  const [communityId, setCommunityId] = useState(null);

  const isCoordinator = AuthService.getUserRoles().includes(
    rolesList.coordinator.name
  );

  const { data: schoolsResponse } = useSchools(communityId, isCoordinator);
  const { data: codeResponse } = useAbsenceCodes(communityId);
  const { data: groupsResponse } = useGroups(communityId);
  const { data: usersResponse } = useOrganizationUsers(communityId);
  const { data: organizationsResponse } = useOrganizations();

  const schools = useMemo(
    () => schoolsResponse?.data?.data || [],
    [schoolsResponse]
  );

  const codeListData = useMemo(() => {
  
    return (
      codeResponse?.data?.data?.map((element) => ({
        ...element,
        code: element.vCode,
        codeValue: element.vCodeValue,
        codeName: `${element.vCode} - ${element.vCodeValue}`,
      })) || []
    );
  }, [codeResponse]);

  const groupsData = useMemo(
    () => groupsResponse?.data?.data || [],
    [groupsResponse]
  );

  const usersData = useMemo(() => {
    return (
      usersResponse?.data?.data?.flatMap((element) => {
        const fullName = TextLimit.AfwezigeLimitOptionOne(
          element.vFirstName,
          element.vMiddleName ?? "",
          element.vLastName
        ).trim();

        const users = [];

        if (element.vEmail) {
          users.push({
            iAdminId: `${element.iAdminId}_Zakelijk`,
            name: `${fullName} - Zakelijk`,
            email: element.vEmail,
          });
        }

        if (element.vBusinessEmail) {
          users.push({
            iAdminId: `${element.iAdminId}_Privè`,
            name: `${fullName} - Privè`,
            email: element.vBusinessEmail,
          });
        }

        return users;
      }) || []
    );
  }, [usersResponse]);

  const organizationsList = useMemo(
    () => organizationsResponse?.data?.data || [],
    [organizationsResponse]
  );

  const getSchoolsByCommunityId = (id) => {
    setCommunityId(id || null);
  };

  return (
    <WizardContext.Provider
      value={{
        communityId,
        codeListData,
        schools,
        groupsData,
        usersData,
        organizationsList,
        isCoordinator,
        getSchoolsByCommunityId,
        setCommunityId,
      }}
    >
      {children}
    </WizardContext.Provider>
  );
};

export const useWizardContext = () => useContext(WizardContext);
